import { IonContent, IonPage } from '@ionic/react';
import { SignUp } from '@clerk/clerk-react';
import { Link, useLocation } from 'react-router-dom';
import revLogo from '../assets/REV_logo.svg';
import revLogoWhite from '../assets/REV_logo_white.svg';

export const SignUpPage: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get('email') || '';

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="flex items-center px-4 py-4">
          <Link to="/" className="flex items-center">
            <img src={revLogo} alt="REV Logo" className="h-8 w-auto dark:hidden" />
            <img src={revLogo} alt="REV Logo" className="h-8 w-auto hidden dark:block" />
          </Link>
        </div>
        <div className="flex items-center justify-center min-h-full">
          <SignUp 
            routing="virtual"
            signInUrl="/sign-in"
            initialValues={{ emailAddress: email }}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};